import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { CreateStockColumnRuleRequest, StockColumnRule } from "src/app/domain/models/StockColumnRule";

@Injectable({providedIn: 'root'})
export abstract class StockColumnRuleGateway {
  abstract create(request: CreateStockColumnRuleRequest): Observable<StockColumnRule[]>
  abstract getRulesByStockId(stockId: number): Observable<StockColumnRule[]>
  abstract delete(ruleId: number): Observable<any>
}
